import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-单选",
  "use": "icon-单选-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-单选\"><defs><style type=\"text/css\"></style></defs><path d=\"M511.829108 113.706715c219.430618 0 397.952524 178.520883 397.952524 397.952524S731.259726 909.61074 511.829108 909.61074 113.876584 731.09088 113.876584 511.658216 292.39849 113.706715 511.829108 113.706715M511.829108 63.961754c-247.25636 0-447.696462 200.441125-447.696462 447.696462 0 247.25636 200.440102 447.696462 447.696462 447.696462s447.696462-200.440102 447.696462-447.696462C959.52557 264.402879 759.085468 63.961754 511.829108 63.961754L511.829108 63.961754z\" p-id=\"1141\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/单选.svg
// module id = XaAe
// module chunks = 54